export default __webpack_public_path__ + "static/media/pupainting-icon.154ddc51.jpg";